import { hasPermission, UserInfo } from '../components/Login/common/defaults';
import rootReducer from '../store/Reducers';
import Store from '../store/Store';

/**
 * Checks if user has specified permission. If no user is provided, will use currentUser from redux state.
 * @param {string} permissionName permission to check
 * @param {UserInfo} user optional user to check permission against
 **/
export function isGranted(permissionName: string, user?: UserInfo) {
  if (!user) {
    const { Application } = Store({}, rootReducer).getState() as any;
    const { currentUser } = Application;
    user = currentUser;
  }

  const hasIt = hasPermission(user, permissionName);

  // console.debug(
  //   `checking %c${user.username}%c for permission %c${permissionName}%c (%c${hasIt}%c)`,
  //   'font-weight: bold; font-style: italic;',
  //   '',
  //   'font-weight: bold; font-style: italic;',
  //   '',
  //   'font-weight: bold; font-style: italic;',
  //   ''
  // );

  return hasIt;
}

/**
 * Checks is the currentUser is granted any of the permissions specified
 * @param permissions One or more permissions as parameters
 * @returns
 */
export function isGrantedAny(permissions: string[], user?: UserInfo): boolean {
  if (permissions.length === 0) return true;

  const hasAny = permissions.find((p) => isGranted(p, user))?.length > 0;
  return hasAny;
}

export const permissions = {
  AddEditUser: 'Add/Edit User',
  DataTranscribe: 'Data Transcribe',
  DataEntry: 'Data Entry',
  EditLocation: 'Edit Location',
  EditFars: 'Edit FARS',
  CheckerReview: 'Checker Review',
  EditKeywords: 'Edit Keywords',
  Reviewer: 'Reviewer',
  DmvSearch: 'Dmv Search',
  DeleteReports: 'Delete Reports',
  PowerBICreateReport: 'PowerBI Create Report',
  PowerBIEditReport: 'PowerBI Edit Report',
  PowerBIDeleteReport: 'PowerBI Delete Report',
  PowerBIShareReport: 'PowerBI Share Report',
  PowerBIViewReport: 'PowerBI View Report',
  PowerBIViewAllReports: 'PowerBI View All Reports',
  PowerBIEditAllReports: 'PowerBI Edit All Reports',
  PowerBIDeleteAllReports: 'PowerBI Delete All Reports',
  PowerBIShareAllReports: 'PowerBI Share All Reports',
  WorkZoneSearch: 'Work Zone Search',
  LicensePlateSearch: 'License Plate Search',
  ViewPendingLrs: 'View Pending LRS',
  RoleAdmin: 'Role Admin',
  DataTranscribeValidation: 'Data Transcribe Validation',
  CaseStudySearch: 'Case Study Search',
  FlashlightSearchPrivate: 'Flashlight Search Private',
  FlashlightSearchPublic: 'Flashlight Search Public',
  AdvancedSearch: 'Advanced Search',
  Letters: 'Letters',
  EditLetterTemplates: 'Edit Letter Templates',
  MatchingQueue: 'Matching Queue',
  ManagementQueue: 'Management Queue',
  Extracts: 'Extracts',
  StandardSummary: 'Standard Summary',
  AuditLog: 'Audit Log',
  LookupTypesAdmin: 'Lookup Types Admin',
  RedactFields: 'Redact Fields',
  FormAdmin: 'Form Admin',
  PrintReportSample: 'Print Report Sample',
  ManageVendors: 'Manage Vendors',
  ManageWorkflow: 'Manage Workflow',
  DuplicateSearch: 'Duplicate Search',
  DriverReport: 'Driver Report',
  AddEditKeywords: 'Add/Edit Keywords',
  AdvancedSearchArchivedDatabases: 'Advanced Search Archived Databases',
  GlobalSearch: 'Global Search',
  ExtractsDeleteOwn: 'Extracts - Delete Own',
  ExtractsDeleteAny: 'Extracts - Delete Any',
  Developer: 'Developer',
  LinkReports: 'Link Reports',
  ReportChainEditor: 'Report Chain Editor',
};
